function Mobile({
  children
}) {
  return children;
}

export { Mobile };
